module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction-history/get-receipt/get-receipt.component.css
// module id = ./src/app/transaction-history/get-receipt/get-receipt.component.css
// module chunks = main